import { Plane, Vector3 } from 'three';

import { raycastPlane } from 'app/modules/wallforming/components/scenes/objects/articles/utils/dragUtils';

export function createPlaneFromCandidatePoints(
    candidates: Array<{ position: { x: number; y: number; z: number } }>,
    normal: Vector3 | undefined | null
): Plane | null {
    if (candidates.length === 0 || !normal) {
        return null;
    }

    const anchor = new Vector3();
    for (const candidate of candidates) {
        anchor.add(new Vector3(candidate.position.x, candidate.position.y, candidate.position.z));
    }
    anchor.multiplyScalar(1 / candidates.length);
    raycastPlane.setFromNormalAndCoplanarPoint(normal, anchor);
    return new Plane().setFromNormalAndCoplanarPoint(normal, anchor);
}
